<template>
    <a-modal title="预约寄件" :width="900" :visible="visible" okText="确认发药"
        :maskClosable="false" @cancel="handleCancel" v-if="hackReset">
        <template slot="footer">
            <a-button key="back" @click="handleCancel">
                取消
            </a-button>
            <a-button key="ok" @click="handleSubmit" :loading="confirmLoading">
                确认
            </a-button>

        </template>
        <!--   -->
        <div class="logistics_address">
            <div class="logistics_address_icon">
                <img src="../../../../assets/location.png" alt="">
            </div>
            <div class="logistics_address_message">
                <div>
                    <span>{{this.userAddres.contactName}}</span><span
                        style="padding-left:20px">{{this.userAddres.contactMobile}}</span>
                </div>
                <div>
                    {{this.userAddres.provinceName}}{{this.userAddres.cityName}}{{this.userAddres.areaName}}{{ this.userAddres.address }}{{this.userAddres.addrDetail}}
                </div>
            </div>
        </div>
        <div class="logistics_input" style="border-bottom: 1px solid #e8e8e8;">
            <a-form layout="inline">
                <a-row style="margin-bottom:10px">
                    <a-col :span="12">
                        <a-form-item label="寄件人：" style="width:340px">
                            <a-input v-model="sender.sendManName" placeholder="若有请输入" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="寄件人电话：" style="width:340px">
                            <a-input v-model="sender.sendManMobile" placeholder="请输入寄件人手机号" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row style="margin-bottom:10px">
                    <a-col :span="2" style="width:55px">
                        <span style="padding-left:13px">地址：</span>
                    </a-col>
                    <a-col :span="22">
                        <a-textarea v-model="sender.sendManPrintAddr" @blur="getPackageOrgan" placeholder="请输入寄件人地址"
                            style="width:600px" :auto-size="{ minRows: 2, maxRows: 6 }" />
                    </a-col>
                </a-row>
            </a-form>
        </div>
        <div class="logistics_input">
            <a-form layout="inline">
                <a-row style="margin-bottom:10px">
                    <a-col :span="12">
                        <a-form-item label="物流公司：" style="width:340px">
                            <a-select v-model="parament.com" :options="selectOrgan" placeholder="请选择物流公司"></a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="预约时段：" style="width:340px">
                            <!-- <a-date-picker style="width:110px" @change="changeDate" placeholder="请选择预约日期" /> -->
                            <a-select v-model="parament.dayType" style="width:110px" :options="dateType"
                                placeholder="请选择预约日期"></a-select>
                            <a-time-picker style="width:70px" :minute-step="60" :open="open" :allowClear="false"
                                @openChange="handleOpenChange" format="HH:mm" @change="changeTime" placeholder="请选择">
                                <template #addon>
                                    <a-button size="small" type="primary" @click="handleClose">确认</a-button>
                                </template>
                            </a-time-picker>
                            <a-time-picker style="width:70px" :minute-step="60" :open="opens"
                                @openChange="handleOpenChanges" @change="changeEndTime"
                                :disabledHours="getDisabledHours" format="HH:mm" placeholder="请选择">
                                <template #addon>
                                    <a-button size="small" type="primary" @click="handleCloses">确认</a-button>
                                </template>
                            </a-time-picker>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row style="margin-bottom:10px">
                    <a-col :span="12">
                        <a-form-item label="物品类型：" style="width:340px">
                            <a-select v-model="parament.cargo" :options="sendType" placeholder="请选择物品类型"></a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="预估重量：" style="width:340px">
                            <a-input-number v-model="parament.weight" :min="1" placeholder="请输入重量" /> Kg
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row style="margin-bottom:10px">
                    <a-col :span="12">
                        <a-form-item label="物流编号：" style="width:340px">
                            <a-input v-model="parament.packageCode" placeholder="若有请输入" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="是否保价：" style="width:340p;color: #e23b50;">
                            {{ this.userAddres.insured == '1' ? '是' : '否'  }}
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="2">
                        <span style="padding-left:28px">备注：</span>
                    </a-col>
                    <a-col :span="20">
                        <a-textarea placeholder="请输入备注" style="width:600px" :auto-size="{ minRows: 2, maxRows: 6 }" />
                    </a-col>
                </a-row>
            </a-form>
        </div>
    </a-modal>
</template>

<script>
  import moment from 'moment'
  import { recipeGetAddress , recipeMail , getComSelect } from '@/api/modular/interhospital/recipetable/recipeManage'
  export default {
    data () {
      return {
        visible : false,
        hackReset : true,
        confirmLoading: false,

        // 寄件人信息
        sender : {
            sendManName : '通海县人民医院中心药房',
            sendManMobile : '08776185281',
            sendManPrintAddr : '云南省玉溪市通海县秀山镇富善街33号通海县人民医院中心药房'
        },
        // 收件人信息
        userAddres : {},
        // 物流信息
        parament : {
            cargo : '药品',
            dayType: '今天',
            weight : '1',
        },
        dateType : [
            {
                value: '今天',
                label: '今天',
            },
            {
                value: '明天',
                label: '明天',
            },
            {
                value: '后天',
                label: '后天',
            },
        ],
        sendType : [
            {
                value: '药品',
                label: '药品',
            },
            {
                value: '文件',
                label: '文件',
            },
            {
                value: '其他',
                label: '其他',
            },
        ],
        selectOrgan : [],

        packageOrgan : [
            {
                value: 'debangkuaidi',
                label: '德邦',
            },
            {
                value: 'jd',
                label: '京东物流',
            },
            {
                value: 'shunfeng',
                label: '顺丰速运',
            },
            {
                value: 'huitongkuaidi',
                label: '百世汇通',
            },
            {
                value: 'tiantian',
                label: '天天快递',
            },
            {
                value: 'zhongtong',
                label: '中通快递',
            },
            {
                value: 'yuantong',
                label: '圆通快递',
            },
            {
                value: 'yunda',
                label: '韵达快递',
            },
            {
                value: 'shentong',
                label: '申通快递',
            },
            {
                value: 'zhaijisong',
                label: '宅急送',
            },
            {
                value: 'youshuwuliu',
                label: '优速快递',
            },
        ],
        record : {},
        open : false,
        opens : false,
      }
    },
   
    methods: {
        moment,
        // 初始化方法
        add (record) {
            this.record = record;
            this.visible = true;
            this.parament = {
                com : 'shunfeng',
                cargo : '药品',
                dayType : '今天'
            },
            this.open = false;
            this.opens = false;
            this.confirmLoading = true;
            // 初始化获取收件人信息
            recipeGetAddress({orderId:record.id}).then(res=>{
                this.confirmLoading = false;
                if(res.code == '200'){
                    this.userAddres = res.data;
                    this.getPackageOrgan();
                }else{
                    this.$message.error(res.data.message)
                }
            })
        },
        // 选择时间段
        onRangeChange(){

        },
        onRangeOk(){

        },
        //   关闭弹窗
        handleCancel () {
            this.visible = false;
            this.hackReset = false;
            this.$nextTick(()=>{
                this.hackReset = true;
            })
        },
        // 确定寄件 18622041976
        handleSubmit() {
            this.confirmLoading = true;
            let params = {
                recipeId : this.record.recipeId,
                com : this.parament.com,
                recManName : this.userAddres.contactName,
                recManMobile : this.userAddres.contactMobile,
                recManPrintAddr : this.userAddres.provinceName + this.userAddres.cityName + this.userAddres.addrDetail,
                sendManName : this.sender.sendManName,
                sendManMobile : this.sender.sendManMobile,
                sendManPrintAddr : this.sender.sendManPrintAddr,
                cargo : this.parament.cargo,
                weight : this.parament.weight,
                payment : 'CONSIGNEE',
                dayType : this.parament.dayType,
                pickupStartTime : this.parament.pickupStartTime,
                pickupEndTime : this.parament.pickupEndTime,
            }
            if (!params.sendManMobile) {
                this.$message.info('请输入寄件人手机号');
                this.confirmLoading = false;
                return;
            } else
            if (!params.pickupStartTime) {
                this.$message.info('请选择预约时段');
                this.confirmLoading = false;
                return;
            } else
            if (!params.pickupEndTime) {
                this.$message.info('请选择预约时段');
                this.confirmLoading = false;
                return;
            } else
            if (!params.weight) {
                this.$message.info('请输入预估重量');
                this.confirmLoading = false;
                return;
            }
            recipeMail(params).then(res => {
                this.confirmLoading = false;
                console.log(res);
                if(res.code == 200){
                    this.visible = false;
                    this.$message.success(res.message)
                    this.$parent.handleOk();
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        // 控制禁止选择时间项
        changeDate(val,date){
            this.parament.dayType = date;
        },
        changeTime(val,date){
            this.parament.pickupStartTime = date;
        },
        changeEndTime(val,date){
            this.parament.pickupEndTime = date;
        },
        handleOpenChange(){
            this.open = true;
        },
        handleOpenChanges(){
            if(this.parament.pickupStartTime){
                this.opens = true;
            }else{
                this.$message.info('请先选择开始时间')
            }
            
        },
        handleClose(){
            this.open = false;
        },
        handleCloses(){
            this.opens = false;
        },
        // 限制时间小时
        getDisabledHours(){
            const time = this.parament.pickupStartTime;
            if(time){
                const hours = [];
                const timeArr = time.split(':');
                for(var i=0;i<24;i++){
                    if(i == timeArr[0] ){

                    }else if(i ==  Number(timeArr[0])  + 1 ){

                    }else if(i ==  Number(timeArr[0]) + 2 ){

                    }else{
                        hours.push(i)
                    }
                }
                return hours;
            }else{

            }
        },
        getPackageOrgan(){
            let address = this.userAddres.provinceName + this.userAddres.cityName + this.userAddres.areaName + this.userAddres.address + this.userAddres.addrDetail;
            let params = {  
                sendManPrintAddr : address,
                recManPrintAddr : this.sender.sendManPrintAddr ,
            }
            getComSelect(params).then(res=>{
                if(res.data.code == 200){
                    console.log(res.data.data)
                    this.selectOrgan = [];
                    res.data.data.forEach((item,index)=>{
                        res.data.data[index].value = item.com;
                        res.data.data[index].label = item.comName;
                    })
                    this.selectOrgan = res.data.data;
                }
            })
        }
    }
  }
</script>
<style lang="less" scoped>
.logistics_address{
  display: flex;
  height: 80px;
  padding: 10px;
  border-bottom: 1px solid #e8e8e8;
  .logistics_address_icon{
    &>img{
      width: 60px;
      height: 60px;
    }
    flex: 1;
    max-width: 60px;
    width: 60px;
    height: 60px;
    margin-right: 20px;
  }
  .logistics_address_message{
    flex: 1;
    &>div{
      height: 30px;
      line-height: 30px;
    }
  }
}
.logistics_input{
    padding: 20px 0;
}
/deep/.ant-form-item-control{
    width: 250px;
}
/deep/.ant-input-number{
    width: 120px;
}
/deep/.ant-time-picker >  .ant-time-picker-icon{
    display: none;
}
</style>
